module.exports = __webpack_public_path__ + "img/bg.102e9487.jpg";